"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/get-data.js":
/*!***********************************!*\
  !*** ./js/components/get-data.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getYotpoReviews: () => (/* binding */ getYotpoReviews)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");

var getYotpoReviews = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (productId) {
    var url = "https://api-cdn.yotpo.com/v1/widget/syWV3O0DUgkkpDvutwXXSyHW0ZHmfejdusotXyXD/products/".concat(productId, "/reviews.json");
    var resposeData = yield fetch(url);
    var responseJson = yield resposeData.json();
    var {
      response = {}
    } = responseJson || {};
    var {
      bottomline: yotpoSummary = {}
    } = response;
    var {
      total_review: totalReview,
      average_score: averageScore
    } = yotpoSummary;
    var curatedData = {
      totalReview,
      averageScore
    };
    return curatedData;
  });
  return function getYotpoReviews(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./js/components/landing-page-buy-box/buy-box-store.js":
/*!*************************************************************!*\
  !*** ./js/components/landing-page-buy-box/buy-box-store.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   selectedSellingPlanStore: () => (/* binding */ selectedSellingPlanStore),
/* harmony export */   selectedVariant: () => (/* binding */ selectedVariant),
/* harmony export */   updateSelectedVariant: () => (/* binding */ updateSelectedVariant)
/* harmony export */ });
/* harmony import */ var svelte_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/store */ "./node_modules/svelte/src/runtime/store/index.js");

var selectedVariant = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)({});
var selectedSellingPlanStore = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)(false);
var updateSelectedVariant = _ref => {
  var {
    productId,
    variantObj
  } = _ref;
  selectedVariant.update(contents => {
    contents[productId] = {};
    contents[productId] = variantObj;
    return contents;
  });
};

/***/ }),

/***/ "./js/components/landing-page-buy-box/buy-box.svelte":
/*!***********************************************************!*\
  !*** ./js/components/landing-page-buy-box/buy-box.svelte ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _variant_options_svelte__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./variant-options.svelte */ "./js/components/landing-page-buy-box/variant-options.svelte");
/* harmony import */ var _variant_description_minimal_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./variant-description-minimal.svelte */ "./js/components/landing-page-buy-box/variant-description-minimal.svelte");
/* harmony import */ var _buy_now_button_svelte__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./buy-now-button.svelte */ "./js/components/landing-page-buy-box/buy-now-button.svelte");
/* js/components/landing-page-buy-box/buy-box.svelte generated by Svelte v4.2.19 */








function create_key_block(ctx) {
	let form;
	let div;
	let variantdescriptionminimal;
	let t0;
	let variantoptions;
	let t1;
	let buynowbutton;
	let div_class_value;
	let form_class_value;
	let current;

	variantdescriptionminimal = new _variant_description_minimal_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				wrapperClass: /*wrapperClass*/ ctx[10],
				variantSelectorType: /*settings*/ ctx[7].variantSelectorType,
				productId: /*productId*/ ctx[8],
				productHandle: /*productHandle*/ ctx[5],
				enableShopPayText: /*enableShopPayText*/ ctx[6],
				finalDiscountedPrice: /*finalDiscountedPrice*/ ctx[1],
				showSubscription: /*settings*/ ctx[7].showSubscription,
				discountBgColor: /*settings*/ ctx[7].discountBgColor
			}
		});

	variantoptions = new _variant_options_svelte__WEBPACK_IMPORTED_MODULE_3__["default"]({
			props: {
				wrapperClass: /*wrapperClass*/ ctx[10],
				variants: /*variants*/ ctx[4],
				settings: /*settings*/ ctx[7],
				productId: /*productId*/ ctx[8]
			}
		});

	buynowbutton = new _buy_now_button_svelte__WEBPACK_IMPORTED_MODULE_4__["default"]({
			props: {
				wrapperClass: /*wrapperClass*/ ctx[10],
				productId: /*productId*/ ctx[8],
				productHandle: /*productHandle*/ ctx[5],
				enableShopPayText: /*enableShopPayText*/ ctx[6],
				sellingPlanGroups: /*sellingPlanGroups*/ ctx[9],
				showSubscription: /*settings*/ ctx[7].showSubscription,
				orderDiscount: /*orderDiscount*/ ctx[3],
				nextOrderOnwardsDiscount: /*nextOrderOnwardsDiscount*/ ctx[2],
				finalDiscountedPrice: /*finalDiscountedPrice*/ ctx[1],
				showDiscountText: /*settings*/ ctx[7].showDiscountText
			}
		});

	return {
		c() {
			form = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("form");
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantdescriptionminimal.$$.fragment);
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantoptions.$$.fragment);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(buynowbutton.$$.fragment);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ ctx[10]}__product-info-box`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(form, "action", "");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(form, "class", form_class_value = `${/*wrapperClass*/ ctx[10]}__order-form`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, form, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(form, div);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantdescriptionminimal, div, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantoptions, div, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(buynowbutton, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const variantdescriptionminimal_changes = {};
			if (dirty & /*finalDiscountedPrice*/ 2) variantdescriptionminimal_changes.finalDiscountedPrice = /*finalDiscountedPrice*/ ctx[1];
			variantdescriptionminimal.$set(variantdescriptionminimal_changes);
			const buynowbutton_changes = {};
			if (dirty & /*orderDiscount*/ 8) buynowbutton_changes.orderDiscount = /*orderDiscount*/ ctx[3];
			if (dirty & /*nextOrderOnwardsDiscount*/ 4) buynowbutton_changes.nextOrderOnwardsDiscount = /*nextOrderOnwardsDiscount*/ ctx[2];
			if (dirty & /*finalDiscountedPrice*/ 2) buynowbutton_changes.finalDiscountedPrice = /*finalDiscountedPrice*/ ctx[1];
			buynowbutton.$set(buynowbutton_changes);
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantdescriptionminimal.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantoptions.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(buynowbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantdescriptionminimal.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantoptions.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(buynowbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(form);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantdescriptionminimal);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantoptions);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(buynowbutton);
		}
	};
}

function create_fragment(ctx) {
	let previous_key = Object.keys(/*$selectedVariant*/ ctx[0]).length;
	let key_block_anchor;
	let current;
	let key_block = create_key_block(ctx);

	return {
		c() {
			key_block.c();
			key_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
		},
		m(target, anchor) {
			key_block.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, key_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*$selectedVariant*/ 1 && (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal)(previous_key, previous_key = Object.keys(/*$selectedVariant*/ ctx[0]).length)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(key_block, 1, 1, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
				key_block = create_key_block(ctx);
				key_block.c();
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(key_block, 1);
				key_block.m(key_block_anchor.parentNode, key_block_anchor);
			} else {
				key_block.p(ctx, dirty);
			}
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(key_block);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(key_block);
			current = false;
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(key_block_anchor);
			}

			key_block.d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let currentVariant;
	let orderDiscount;
	let nextOrderOnwardsDiscount;
	let finalDiscountedPrice;
	let $selectedVariant;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_5__.selectedVariant, $$value => $$invalidate(0, $selectedVariant = $$value));
	let { shopifyData } = $$props;
	const { variants, productHandle, enableShopPayText, settings, productId, sellingPlanGroups } = shopifyData || {};
	const { wrapperClass = "landing-page-buy-box" } = settings || {};
	const variantObj = variants[variants.length - 1];
	(0,_buy_box_store__WEBPACK_IMPORTED_MODULE_5__.updateSelectedVariant)({ productId, variantObj });

	$$self.$$set = $$props => {
		if ('shopifyData' in $$props) $$invalidate(11, shopifyData = $$props.shopifyData);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$selectedVariant*/ 1) {
			$: $$invalidate(12, currentVariant = $selectedVariant[productId]);
		}

		if ($$self.$$.dirty & /*currentVariant*/ 4096) {
			$: $$invalidate(3, orderDiscount = currentVariant?.orderDiscount);
		}

		if ($$self.$$.dirty & /*currentVariant*/ 4096) {
			$: $$invalidate(2, nextOrderOnwardsDiscount = currentVariant?.nextOrderOnwardsDiscount);
		}

		if ($$self.$$.dirty & /*currentVariant*/ 4096) {
			$: $$invalidate(1, finalDiscountedPrice = currentVariant?.finalDiscountedPrice);
		}
	};

	return [
		$selectedVariant,
		finalDiscountedPrice,
		nextOrderOnwardsDiscount,
		orderDiscount,
		variants,
		productHandle,
		enableShopPayText,
		settings,
		productId,
		sellingPlanGroups,
		wrapperClass,
		shopifyData,
		currentVariant
	];
}

class Buy_box extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, { shopifyData: 11 });
	}

	get shopifyData() {
		return this.$$.ctx[11];
	}

	set shopifyData(shopifyData) {
		this.$$set({ shopifyData });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Buy_box, {"shopifyData":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Buy_box);

/***/ }),

/***/ "./js/components/landing-page-buy-box/buy-now-button.svelte":
/*!******************************************************************!*\
  !*** ./js/components/landing-page-buy-box/buy-now-button.svelte ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* js/components/landing-page-buy-box/buy-now-button.svelte generated by Svelte v4.2.19 */





function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[31] = list[i];
	const constants_0 = /*selectedSellingPlanGroup*/ child_ctx[9] === /*group*/ child_ctx[31].id;
	child_ctx[32] = constants_0;
	const constants_1 = /*showSubscription*/ child_ctx[3] && /*requiresSellingPlan*/ child_ctx[5] && /*sellingPlanGroups*/ child_ctx[2][0].id === /*group*/ child_ctx[31].id && !/*selectedSellingPlanGroup*/ child_ctx[9];
	child_ctx[33] = constants_1;
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[36] = list[i];
	return child_ctx;
}

// (137:0) {#if showSubscription && sellingPlanGroups && sellingPlanGroups.length > 0}
function create_if_block_2(ctx) {
	let div;
	let fieldset;
	let legend;
	let span;
	let t0;
	let span_class_value;
	let legend_class_value;
	let t1;
	let t2;
	let fieldset_class_value;
	let div_class_value;
	let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*sellingPlanGroups*/ ctx[2]);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block = !/*requiresSellingPlan*/ ctx[5] && create_if_block_3(ctx);

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			fieldset = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("fieldset");
			legend = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("legend");
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Frequency");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value = `${/*wrapperClass*/ ctx[0]}__radio-legend-label`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(legend, "class", legend_class_value = `${/*wrapperClass*/ ctx[0]}__radio-legend`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(fieldset, "class", fieldset_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subscription`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, fieldset);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, legend);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(legend, span);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, t1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(fieldset, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, t2);
			if (if_block) if_block.m(fieldset, null);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*wrapperClass*/ 1 && span_class_value !== (span_class_value = `${/*wrapperClass*/ ctx[0]}__radio-legend-label`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value);
			}

			if (dirty[0] & /*wrapperClass*/ 1 && legend_class_value !== (legend_class_value = `${/*wrapperClass*/ ctx[0]}__radio-legend`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(legend, "class", legend_class_value);
			}

			if (dirty[0] & /*wrapperClass, sellingPlanGroups, selectedSellingPlan, showSubscription, requiresSellingPlan, handleSellingPlanChange, selectedSellingPlanGroup, orderDiscount, handleSellingPlanGroupChange*/ 26221) {
				each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*sellingPlanGroups*/ ctx[2]);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(fieldset, t2);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (!/*requiresSellingPlan*/ ctx[5]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(fieldset, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty[0] & /*wrapperClass*/ 1 && fieldset_class_value !== (fieldset_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(fieldset, "class", fieldset_class_value);
			}

			if (dirty[0] & /*wrapperClass*/ 1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subscription`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
			if (if_block) if_block.d();
		}
	};
}

// (165:20) {#if isGroupSelected || isPreselected}
function create_if_block_4(ctx) {
	let div;
	let div_class_value;
	let each_value_1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*group*/ ctx[31].selling_plans);
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-plans`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*wrapperClass, sellingPlanGroups, selectedSellingPlan, showSubscription, requiresSellingPlan, handleSellingPlanChange*/ 9261) {
				each_value_1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*group*/ ctx[31].selling_plans);
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}

			if (dirty[0] & /*wrapperClass*/ 1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-plans`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
		}
	};
}

// (167:28) {#each group.selling_plans as plan}
function create_each_block_1(ctx) {
	let label;
	let input;
	let input_value_value;
	let input_checked_value;
	let t0;
	let span;
	let t1_value = /*plan*/ ctx[36].name + "";
	let t1;
	let label_class_value;
	let mounted;
	let dispose;

	function change_handler_1() {
		return /*change_handler_1*/ ctx[25](/*plan*/ ctx[36]);
	}

	return {
		c() {
			label = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
			input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", "selling_plan");
			input.value = input_value_value = /*plan*/ ctx[36].id;
			input.checked = input_checked_value = /*selectedSellingPlan*/ ctx[10] === /*plan*/ ctx[36].id || /*showSubscription*/ ctx[3] && /*requiresSellingPlan*/ ctx[5] && /*sellingPlanGroups*/ ctx[2][0].selling_plans[0].id === /*plan*/ ctx[36].id && !/*selectedSellingPlan*/ ctx[10];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, label, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, input);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, span);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t1);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", change_handler_1);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*sellingPlanGroups*/ 4 && input_value_value !== (input_value_value = /*plan*/ ctx[36].id)) {
				input.value = input_value_value;
			}

			if (dirty[0] & /*selectedSellingPlan, sellingPlanGroups, showSubscription, requiresSellingPlan*/ 1068 && input_checked_value !== (input_checked_value = /*selectedSellingPlan*/ ctx[10] === /*plan*/ ctx[36].id || /*showSubscription*/ ctx[3] && /*requiresSellingPlan*/ ctx[5] && /*sellingPlanGroups*/ ctx[2][0].selling_plans[0].id === /*plan*/ ctx[36].id && !/*selectedSellingPlan*/ ctx[10])) {
				input.checked = input_checked_value;
			}

			if (dirty[0] & /*sellingPlanGroups*/ 4 && t1_value !== (t1_value = /*plan*/ ctx[36].name + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, t1_value);

			if (dirty[0] & /*wrapperClass*/ 1 && label_class_value !== (label_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(label);
			}

			mounted = false;
			dispose();
		}
	};
}

// (144:12) {#each sellingPlanGroups as group}
function create_each_block(ctx) {
	let div;
	let label;
	let input;
	let input_value_value;
	let input_checked_value;
	let t0;
	let span2;
	let span0;
	let t2;
	let span1;
	let t3;
	let t4;
	let t5;
	let span2_class_value;
	let label_class_value;
	let t6;
	let div_class_value;
	let mounted;
	let dispose;

	function change_handler() {
		return /*change_handler*/ ctx[24](/*group*/ ctx[31]);
	}

	let if_block = (/*isGroupSelected*/ ctx[32] || /*isPreselected*/ ctx[33]) && create_if_block_4(ctx);

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			label = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
			input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "MONTHLY DELIVERY";
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Save ");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*orderDiscount*/ ctx[6]);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("% today, delivery every 30 days*");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", "selling-plan-group");
			input.value = input_value_value = /*group*/ ctx[31].id;
			input.checked = input_checked_value = /*isGroupSelected*/ ctx[32] || /*isPreselected*/ ctx[33];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", "plans--text");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span2, "class", span2_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option--plans`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-group ${/*wrapperClass*/ ctx[0]}__product-subs-group--subscription`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, label);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, input);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, span2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span2, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span2, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span2, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t6);
			if (if_block) if_block.m(div, null);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", change_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*sellingPlanGroups*/ 4 && input_value_value !== (input_value_value = /*group*/ ctx[31].id)) {
				input.value = input_value_value;
			}

			if (dirty[0] & /*selectedSellingPlanGroup, sellingPlanGroups, showSubscription, requiresSellingPlan*/ 556 && input_checked_value !== (input_checked_value = /*isGroupSelected*/ ctx[32] || /*isPreselected*/ ctx[33])) {
				input.checked = input_checked_value;
			}

			if (dirty[0] & /*orderDiscount*/ 64) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t4, /*orderDiscount*/ ctx[6]);

			if (dirty[0] & /*wrapperClass*/ 1 && span2_class_value !== (span2_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option--plans`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span2, "class", span2_class_value);
			}

			if (dirty[0] & /*wrapperClass*/ 1 && label_class_value !== (label_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value);
			}

			if (/*isGroupSelected*/ ctx[32] || /*isPreselected*/ ctx[33]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_4(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty[0] & /*wrapperClass*/ 1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-group ${/*wrapperClass*/ ctx[0]}__product-subs-group--subscription`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}

			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};
}

// (184:12) {#if !requiresSellingPlan}
function create_if_block_3(ctx) {
	let div;
	let label;
	let input;
	let input_checked_value;
	let t0;
	let span;
	let label_class_value;
	let div_class_value;
	let mounted;
	let dispose;

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			label = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
			input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = "One-time purchase";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", "selling-plan-group");
			input.value = "";
			input.checked = input_checked_value = !/*selectedSellingPlanGroup*/ ctx[9];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-group`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, label);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, input);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, span);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", /*change_handler_2*/ ctx[26]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*selectedSellingPlanGroup*/ 512 && input_checked_value !== (input_checked_value = !/*selectedSellingPlanGroup*/ ctx[9])) {
				input.checked = input_checked_value;
			}

			if (dirty[0] & /*wrapperClass*/ 1 && label_class_value !== (label_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-option`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value);
			}

			if (dirty[0] & /*wrapperClass*/ 1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ ctx[0]}__product-subs-group`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}

			mounted = false;
			dispose();
		}
	};
}

// (211:0) {#if showDiscountText && (orderDiscount || nextOrderOnwardsDiscount)}
function create_if_block_1(ctx) {
	let div;
	let span;
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let span_class_value;
	let div_class_value;

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("*Save ");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*orderDiscount*/ ctx[6]);
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("% today and ");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*nextOrderOnwardsDiscount*/ ctx[7]);
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("% on every order thereafter.");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value = `${/*wrapperClass*/ ctx[0]}__condition-text`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ ctx[0]}__condition-container`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, span);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t4);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*orderDiscount*/ 64) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, /*orderDiscount*/ ctx[6]);
			if (dirty[0] & /*nextOrderOnwardsDiscount*/ 128) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t3, /*nextOrderOnwardsDiscount*/ ctx[7]);

			if (dirty[0] & /*wrapperClass*/ 1 && span_class_value !== (span_class_value = `${/*wrapperClass*/ ctx[0]}__condition-text`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value);
			}

			if (dirty[0] & /*wrapperClass*/ 1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ ctx[0]}__condition-container`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}
		}
	};
}

// (218:0) {#if paymentTerms && enableShopPayText && !selectedSellingPlanGroup}
function create_if_block(ctx) {
	let div;
	let div_class_value;

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ ctx[0]}__payment-terms`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			div.innerHTML = /*paymentTerms*/ ctx[8];
		},
		p(ctx, dirty) {
			if (dirty[0] & /*paymentTerms*/ 256) div.innerHTML = /*paymentTerms*/ ctx[8];;

			if (dirty[0] & /*wrapperClass*/ 1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ ctx[0]}__payment-terms`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let div1;
	let div0;
	let button;
	let t1;
	let t2;
	let button_class_value;
	let div0_class_value;
	let div1_class_value;
	let t3;
	let t4;
	let if_block2_anchor;
	let mounted;
	let dispose;
	let if_block0 = /*showSubscription*/ ctx[3] && /*sellingPlanGroups*/ ctx[2] && /*sellingPlanGroups*/ ctx[2].length > 0 && create_if_block_2(ctx);
	let if_block1 = /*showDiscountText*/ ctx[4] && (/*orderDiscount*/ ctx[6] || /*nextOrderOnwardsDiscount*/ ctx[7]) && create_if_block_1(ctx);
	let if_block2 = /*paymentTerms*/ ctx[8] && /*enableShopPayText*/ ctx[1] && !/*selectedSellingPlanGroup*/ ctx[9] && create_if_block(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("ADD TO CART • ");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*displayPrice*/ ctx[11]);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block2) if_block2.c();
			if_block2_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "class", button_class_value = `shopify-buy__btn ${/*wrapperClass*/ ctx[0]}__shopify-buy__btn`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[0]}__checkout-btn`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ ctx[0]}__product-buy-button`);
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, button);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(button, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(button, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t3, anchor);
			if (if_block1) if_block1.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, if_block2_anchor, anchor);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(button, "click", /*handleBuyBox*/ ctx[12]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*showSubscription*/ ctx[3] && /*sellingPlanGroups*/ ctx[2] && /*sellingPlanGroups*/ ctx[2].length > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty[0] & /*displayPrice*/ 2048) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t2, /*displayPrice*/ ctx[11]);

			if (dirty[0] & /*wrapperClass*/ 1 && button_class_value !== (button_class_value = `shopify-buy__btn ${/*wrapperClass*/ ctx[0]}__shopify-buy__btn`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "class", button_class_value);
			}

			if (dirty[0] & /*wrapperClass*/ 1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[0]}__checkout-btn`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (dirty[0] & /*wrapperClass*/ 1 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ ctx[0]}__product-buy-button`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}

			if (/*showDiscountText*/ ctx[4] && (/*orderDiscount*/ ctx[6] || /*nextOrderOnwardsDiscount*/ ctx[7])) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					if_block1.m(t4.parentNode, t4);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*paymentTerms*/ ctx[8] && /*enableShopPayText*/ ctx[1] && !/*selectedSellingPlanGroup*/ ctx[9]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t0);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t3);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t4);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(if_block2_anchor);
			}

			if (if_block0) if_block0.d(detaching);
			if (if_block1) if_block1.d(detaching);
			if (if_block2) if_block2.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let displayPriceRaw;
	let displayPrice;
	let $selectedVariant;
	let $selectedSellingPlanStore;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedVariant, $$value => $$invalidate(22, $selectedVariant = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore, $$value => $$invalidate(23, $selectedSellingPlanStore = $$value));
	let { wrapperClass } = $$props;
	let { productId } = $$props;
	let { productHandle } = $$props;
	let { enableShopPayText } = $$props;
	let { sellingPlanGroups } = $$props;
	let { showSubscription } = $$props;
	let { showDiscountText } = $$props;
	let { requiresSellingPlan = false } = $$props;
	let { orderDiscount } = $$props;
	let { nextOrderOnwardsDiscount } = $$props;
	let { finalDiscountedPrice } = $$props;
	let selectedVariantId, price, priceWithoutCurrency;
	let paymentTerms = false;
	let selectedSellingPlanGroup = null;
	let selectedSellingPlan = null;
	let isInitialized = false;
	const currency = window.storeCurrency || 'USD';
	const locale = window.storeLocale || 'en-US';

	const updateShoppay = async selectedVariantId => {
		const response = await fetch(`/products/${productHandle}?view=payment-terms&variant=${selectedVariantId}`);
		const text = await response.text();
		const html = new DOMParser().parseFromString(text, "text/html");
		const paymentTermsFromFetch = html.querySelector('.shop-pay-terms');

		if (paymentTermsFromFetch) {
			$$invalidate(8, paymentTerms = paymentTermsFromFetch.innerHTML);
			window.dispatchEvent(new Event('resize'));
		}
	};

	const handleBuyBox = async () => {
		try {
			const cartData = { id: selectedVariantId, quantity: 1 };

			if (showSubscription && selectedSellingPlan) {
				cartData.selling_plan = selectedSellingPlan;
			}

			const response = await fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(cartData)
			});

			if (response.ok) {
				// Successfully added to cart, redirect to checkout
				window.location.href = '/checkout';
			} else {
				// Handle error
				const errorData = await response.json();

				console.error('Error adding to cart:', errorData);
				alert('Error adding product to cart. Please try again.');
			}
		} catch(error) {
			console.error('Error:', error);
			alert('Error adding product to cart. Please try again.');
		}
	};

	const handleSellingPlanChange = planId => {
		$$invalidate(10, selectedSellingPlan = planId);
		_buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
	};

	const handleSellingPlanGroupChange = groupId => {
		$$invalidate(9, selectedSellingPlanGroup = groupId);

		if (groupId) {
			const group = sellingPlanGroups.find(g => g.id === groupId);

			if (group && group.selling_plans.length > 0) {
				$$invalidate(10, selectedSellingPlan = group.selling_plans[0].id);
				_buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
			}
		} else {
			$$invalidate(10, selectedSellingPlan = null);
			_buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(false);
		}
	};

	window.custom = {};
	window.custom["handleBuyBox"] = handleBuyBox;
	const change_handler = group => handleSellingPlanGroupChange(group.id);
	const change_handler_1 = plan => handleSellingPlanChange(plan.id);
	const change_handler_2 = () => handleSellingPlanGroupChange(null);

	$$self.$$set = $$props => {
		if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
		if ('productId' in $$props) $$invalidate(15, productId = $$props.productId);
		if ('productHandle' in $$props) $$invalidate(16, productHandle = $$props.productHandle);
		if ('enableShopPayText' in $$props) $$invalidate(1, enableShopPayText = $$props.enableShopPayText);
		if ('sellingPlanGroups' in $$props) $$invalidate(2, sellingPlanGroups = $$props.sellingPlanGroups);
		if ('showSubscription' in $$props) $$invalidate(3, showSubscription = $$props.showSubscription);
		if ('showDiscountText' in $$props) $$invalidate(4, showDiscountText = $$props.showDiscountText);
		if ('requiresSellingPlan' in $$props) $$invalidate(5, requiresSellingPlan = $$props.requiresSellingPlan);
		if ('orderDiscount' in $$props) $$invalidate(6, orderDiscount = $$props.orderDiscount);
		if ('nextOrderOnwardsDiscount' in $$props) $$invalidate(7, nextOrderOnwardsDiscount = $$props.nextOrderOnwardsDiscount);
		if ('finalDiscountedPrice' in $$props) $$invalidate(17, finalDiscountedPrice = $$props.finalDiscountedPrice);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*sellingPlanGroups, isInitialized*/ 1048580) {
			$: if (sellingPlanGroups && sellingPlanGroups.length > 0 && !isInitialized) {
				$$invalidate(9, selectedSellingPlanGroup = sellingPlanGroups[0].id);
				$$invalidate(10, selectedSellingPlan = sellingPlanGroups[0].selling_plans[0].id);
				_buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
				$$invalidate(20, isInitialized = true);
			}
		}

		if ($$self.$$.dirty[0] & /*showSubscription*/ 8) {
			// Reset subscription state when showSubscription is false
			$: if (!showSubscription) {
				$$invalidate(9, selectedSellingPlanGroup = null);
				$$invalidate(10, selectedSellingPlan = null);
				_buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(false);
			}
		}

		if ($$self.$$.dirty[0] & /*$selectedVariant, productId*/ 4227072) {
			$: {
				const variant = $selectedVariant[productId];
				$$invalidate(18, selectedVariantId = variant.id);
				price = variant.price;
				$$invalidate(19, priceWithoutCurrency = variant.priceWithoutCurrency);
			}
		}

		if ($$self.$$.dirty[0] & /*showSubscription, priceWithoutCurrency, $selectedSellingPlanStore, finalDiscountedPrice*/ 9043976) {
			$: $$invalidate(21, displayPriceRaw = (() => {
				if (!showSubscription) {
					// Always use regular price when subscriptions are hidden
					return priceWithoutCurrency;
				} else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice))) {
					// Use subscription price when subscriptions are shown and selected
					return parseFloat(finalDiscountedPrice);
				} else {
					// Use regular price when subscriptions are shown but not selected
					return priceWithoutCurrency;
				}
			})());
		}

		if ($$self.$$.dirty[0] & /*displayPriceRaw*/ 2097152) {
			$: $$invalidate(11, displayPrice = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(displayPriceRaw));
		}

		if ($$self.$$.dirty[0] & /*selectedVariantId*/ 262144) {
			$: (updateShoppay(selectedVariantId), selectedVariantId);
		}
	};

	return [
		wrapperClass,
		enableShopPayText,
		sellingPlanGroups,
		showSubscription,
		showDiscountText,
		requiresSellingPlan,
		orderDiscount,
		nextOrderOnwardsDiscount,
		paymentTerms,
		selectedSellingPlanGroup,
		selectedSellingPlan,
		displayPrice,
		handleBuyBox,
		handleSellingPlanChange,
		handleSellingPlanGroupChange,
		productId,
		productHandle,
		finalDiscountedPrice,
		selectedVariantId,
		priceWithoutCurrency,
		isInitialized,
		displayPriceRaw,
		$selectedVariant,
		$selectedSellingPlanStore,
		change_handler,
		change_handler_1,
		change_handler_2
	];
}

class Buy_now_button extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(
			this,
			options,
			instance,
			create_fragment,
			svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal,
			{
				wrapperClass: 0,
				productId: 15,
				productHandle: 16,
				enableShopPayText: 1,
				sellingPlanGroups: 2,
				showSubscription: 3,
				showDiscountText: 4,
				requiresSellingPlan: 5,
				orderDiscount: 6,
				nextOrderOnwardsDiscount: 7,
				finalDiscountedPrice: 17
			},
			null,
			[-1, -1]
		);
	}

	get wrapperClass() {
		return this.$$.ctx[0];
	}

	set wrapperClass(wrapperClass) {
		this.$$set({ wrapperClass });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get productId() {
		return this.$$.ctx[15];
	}

	set productId(productId) {
		this.$$set({ productId });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get productHandle() {
		return this.$$.ctx[16];
	}

	set productHandle(productHandle) {
		this.$$set({ productHandle });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get enableShopPayText() {
		return this.$$.ctx[1];
	}

	set enableShopPayText(enableShopPayText) {
		this.$$set({ enableShopPayText });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get sellingPlanGroups() {
		return this.$$.ctx[2];
	}

	set sellingPlanGroups(sellingPlanGroups) {
		this.$$set({ sellingPlanGroups });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get showSubscription() {
		return this.$$.ctx[3];
	}

	set showSubscription(showSubscription) {
		this.$$set({ showSubscription });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get showDiscountText() {
		return this.$$.ctx[4];
	}

	set showDiscountText(showDiscountText) {
		this.$$set({ showDiscountText });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get requiresSellingPlan() {
		return this.$$.ctx[5];
	}

	set requiresSellingPlan(requiresSellingPlan) {
		this.$$set({ requiresSellingPlan });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get orderDiscount() {
		return this.$$.ctx[6];
	}

	set orderDiscount(orderDiscount) {
		this.$$set({ orderDiscount });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get nextOrderOnwardsDiscount() {
		return this.$$.ctx[7];
	}

	set nextOrderOnwardsDiscount(nextOrderOnwardsDiscount) {
		this.$$set({ nextOrderOnwardsDiscount });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get finalDiscountedPrice() {
		return this.$$.ctx[17];
	}

	set finalDiscountedPrice(finalDiscountedPrice) {
		this.$$set({ finalDiscountedPrice });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Buy_now_button, {"wrapperClass":{},"productId":{},"productHandle":{},"enableShopPayText":{},"sellingPlanGroups":{},"showSubscription":{},"showDiscountText":{},"requiresSellingPlan":{"type":"Boolean"},"orderDiscount":{},"nextOrderOnwardsDiscount":{},"finalDiscountedPrice":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Buy_now_button);

/***/ }),

/***/ "./js/components/landing-page-buy-box/star-reviews.svelte":
/*!****************************************************************!*\
  !*** ./js/components/landing-page-buy-box/star-reviews.svelte ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! svelte */ "./node_modules/svelte/src/runtime/index.js");
/* harmony import */ var JsComponents_get_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! JsComponents/get-data */ "./js/components/get-data.js");
/* harmony import */ var JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/scroll-on-click */ "./js/components/scroll-on-click.js");
/* js/components/landing-page-buy-box/star-reviews.svelte generated by Svelte v4.2.19 */







function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	return child_ctx;
}

// (36:2) {#if reviewData}
function create_if_block(ctx) {
	let div0;
	let t0;
	let div1;
	let t1_value = parseFloat(/*reviewData*/ ctx[0].averageScore).toFixed(1) + "";
	let t1;
	let t2;
	let t3;
	let div2;
	let t4_value = /*reviewData*/ ctx[0].totalReview + "";
	let t4;
	let t5;
	let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)([1, 2, 3, 4, 5]);
	let each_blocks = [];

	for (let i = 0; i < 5; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < 5; i += 1) {
				each_blocks[i].c();
			}

			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" / 5");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t4_value);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" REVIEWS");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", "landing-page-buy-box__reviews-stars landing-page-buy-box__review-item");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", "review__average landing-page-buy-box__review-item");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", "review__count landing-page-buy-box__review-item");
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div0, anchor);

			for (let i = 0; i < 5; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div0, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t3, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div2, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t5);
		},
		p(ctx, dirty) {
			if (dirty & /*filledStarIcon, Math, reviewData, halfFilledStarIcon, unfilledStarIcon*/ 15) {
				each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)([1, 2, 3, 4, 5]);
				let i;

				for (i = 0; i < 5; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div0, null);
					}
				}

				for (; i < 5; i += 1) {
					each_blocks[i].d(1);
				}
			}

			if (dirty & /*reviewData*/ 1 && t1_value !== (t1_value = parseFloat(/*reviewData*/ ctx[0].averageScore).toFixed(1) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, t1_value);
			if (dirty & /*reviewData*/ 1 && t4_value !== (t4_value = /*reviewData*/ ctx[0].totalReview + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t4, t4_value);
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div0);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t0);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t3);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div2);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
		}
	};
}

// (44:10) {:else}
function create_else_block(ctx) {
	let html_tag;
	let html_anchor;

	return {
		c() {
			html_tag = new svelte_internal__WEBPACK_IMPORTED_MODULE_0__.HtmlTag(false);
			html_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
			html_tag.a = html_anchor;
		},
		m(target, anchor) {
			html_tag.m(/*unfilledStarIcon*/ ctx[3], target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, html_anchor, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(html_anchor);
				html_tag.d();
			}
		}
	};
}

// (42:102) 
function create_if_block_2(ctx) {
	let html_tag;
	let html_anchor;

	return {
		c() {
			html_tag = new svelte_internal__WEBPACK_IMPORTED_MODULE_0__.HtmlTag(false);
			html_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
			html_tag.a = html_anchor;
		},
		m(target, anchor) {
			html_tag.m(/*halfFilledStarIcon*/ ctx[2], target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, html_anchor, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(html_anchor);
				html_tag.d();
			}
		}
	};
}

// (40:10) {#if star <= Math.floor(reviewData.averageScore)}
function create_if_block_1(ctx) {
	let html_tag;
	let html_anchor;

	return {
		c() {
			html_tag = new svelte_internal__WEBPACK_IMPORTED_MODULE_0__.HtmlTag(false);
			html_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
			html_tag.a = html_anchor;
		},
		m(target, anchor) {
			html_tag.m(/*filledStarIcon*/ ctx[1], target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, html_anchor, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(html_anchor);
				html_tag.d();
			}
		}
	};
}

// (38:6) {#each [1, 2, 3, 4, 5] as star}
function create_each_block(ctx) {
	let div;
	let show_if;
	let show_if_1;
	let t;

	function select_block_type(ctx, dirty) {
		if (dirty & /*reviewData*/ 1) show_if = null;
		if (dirty & /*reviewData*/ 1) show_if_1 = null;
		if (show_if == null) show_if = !!(/*star*/ ctx[6] <= Math.floor(/*reviewData*/ ctx[0].averageScore));
		if (show_if) return create_if_block_1;
		if (show_if_1 == null) show_if_1 = !!(/*star*/ ctx[6] === Math.ceil(/*reviewData*/ ctx[0].averageScore) && /*reviewData*/ ctx[0].averageScore % 1 >= 0.5);
		if (show_if_1) return create_if_block_2;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if_block.c();
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "landing-page-buy-box__review-star");
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			if_block.m(div, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, t);
				}
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}

			if_block.d();
		}
	};
}

function create_fragment(ctx) {
	let div;
	let if_block = /*reviewData*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if (if_block) if_block.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "landing-page-buy-box__reviews review");
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			if (if_block) if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (/*reviewData*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}

			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { shopifyData } = $$props;
	let reviewData = false;
	const { productId } = shopifyData;
	(0,JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__.scrollOnClick)('.product-buy-button', '.landing-page-buy-box.landing-page-buy-box--alternate', 80);
	(0,JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__.scrollOnClick)('.product-buy-button-mian', '[custom-buy-box]', 100);

	const filledStarIcon = `<svg width="10" height="10" class="{{ class }}" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
    </svg> `;

	const halfFilledStarIcon = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="half-fill">
          <rect x="0" y="0" width="5" height="10" />
        </clipPath>
      </defs>
      <path opacity="0.25" d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
      <path clip-path="url(#half-fill)" d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
    </svg>`;

	const unfilledStarIcon = `<svg width="10" height="10" class="{{ class }}" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.25" d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
    </svg>`;

	(0,svelte__WEBPACK_IMPORTED_MODULE_2__.onMount)(() => {
		(async () => {
			$$invalidate(0, reviewData = await (0,JsComponents_get_data__WEBPACK_IMPORTED_MODULE_4__.getYotpoReviews)(productId));
		})();
	});

	$$self.$$set = $$props => {
		if ('shopifyData' in $$props) $$invalidate(4, shopifyData = $$props.shopifyData);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*reviewData*/ 1) {
			$: reviewData && (0,JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__.scrollOnClick)('.landing-page-buy-box__reviews', '.synchro-reviews', 100);
		}
	};

	return [reviewData, filledStarIcon, halfFilledStarIcon, unfilledStarIcon, shopifyData];
}

class Star_reviews extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, { shopifyData: 4 });
	}

	get shopifyData() {
		return this.$$.ctx[4];
	}

	set shopifyData(shopifyData) {
		this.$$set({ shopifyData });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Star_reviews, {"shopifyData":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Star_reviews);

/***/ }),

/***/ "./js/components/landing-page-buy-box/sticky-buy-box.svelte":
/*!******************************************************************!*\
  !*** ./js/components/landing-page-buy-box/sticky-buy-box.svelte ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/responsive-image.svelte */ "./js/components/responsive-image.svelte");
/* js/components/landing-page-buy-box/sticky-buy-box.svelte generated by Svelte v4.2.19 */






function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	child_ctx[7] = i;
	const constants_0 = parseFloat(/*variant*/ child_ctx[4].price.replace(/[^0-9.]/g, '')) < parseFloat(/*variant*/ child_ctx[4].compareAtPrice.replace(/[^0-9.]/g, ''));
	child_ctx[5] = constants_0;
	return child_ctx;
}

// (24:6) {:else}
function create_else_block(ctx) {
	let div;

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div.textContent = `${/*variant*/ ctx[4].name.split('-')[0].split('+')[0].split('·')[0]}`;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "floating-purchase-options__quantity");
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}
		}
	};
}

// (22:6) {#if flag}
function create_if_block_1(ctx) {
	let div;

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div.textContent = `${/*variant*/ ctx[4].customVariantText}`;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "floating-purchase-options__quantity");
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}
		}
	};
}

// (29:8) {#if hasDiscount}
function create_if_block(ctx) {
	let span;

	return {
		c() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = `${/*variant*/ ctx[4].compareAtPrice}`;
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, span, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(span);
			}
		}
	};
}

// (10:0) {#each variants as variant, index }
function create_each_block(ctx) {
	let div3;
	let responsiveimage;
	let t0;
	let div0;
	let t1;
	let div2;
	let t2;
	let div1;
	let t3_value = /*variant*/ ctx[4].price + "";
	let t3;
	let t4;
	let t5;
	let a;
	let t6;
	let a_href_value;
	let t7;
	let div3_class_value;
	let div3_data_index_value;
	let current;
	let mounted;
	let dispose;

	responsiveimage = new JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				image: /*variant*/ ctx[4].image,
				image_aspect_ratio: 1
			}
		});

	function select_block_type(ctx, dirty) {
		if (flag) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block0 = current_block_type(ctx);
	let if_block1 = /*hasDiscount*/ ctx[5] && create_if_block(ctx);

	function click_handler() {
		return /*click_handler*/ ctx[3](/*variant*/ ctx[4]);
	}

	return {
		c() {
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(responsiveimage.$$.fragment);
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if_block0.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t3_value);
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			a = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("a");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Buy Now");
			t7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", "floating-purchase-options__divider");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", "floating-purchase-options__price");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", "floating-purchase-options__details");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(a, "class", "a--cta");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(a, "href", a_href_value = `/cart/${/*variant*/ ctx[4].id}:1`);

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value = "floating-purchase-options__item floating-purchase-options__item" + /*index*/ ctx[7] + " " + (/*hasDiscount*/ ctx[5]
			? ''
			: 'floating-purchase-options__item-small-container'));

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "data-index", div3_data_index_value = /*index*/ ctx[7]);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div3, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(responsiveimage, div3, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div2);
			if_block0.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t4);
			if (if_block1) if_block1.m(div1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, a);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(a, t6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t7);
			current = true;

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(div3, "click", click_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if_block0.p(ctx, dirty);
			if (/*hasDiscount*/ ctx[5]) if_block1.p(ctx, dirty);
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(responsiveimage.$$.fragment, local);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(responsiveimage.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div3);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(responsiveimage);
			if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let each_1_anchor;
	let current;
	let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ ctx[0]);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*parseFloat, variants, window, flag*/ 1) {
				each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ ctx[0]);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(each_1_anchor);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
		}
	};
}

const flag = true; //set true, to display custom variant name(metafield)

function instance($$self, $$props, $$invalidate) {
	let $selectedVariant;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedVariant, $$value => $$invalidate(2, $selectedVariant = $$value));
	let { shopifyData } = $$props;
	const { variants } = shopifyData || {};
	const click_handler = variant => window.location.href = `/cart/${variant.id}:1`;

	$$self.$$set = $$props => {
		if ('shopifyData' in $$props) $$invalidate(1, shopifyData = $$props.shopifyData);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$selectedVariant*/ 4) {
			$: console.log($selectedVariant);
		}
	};

	return [variants, shopifyData, $selectedVariant, click_handler];
}

class Sticky_buy_box extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, { shopifyData: 1 });
	}

	get shopifyData() {
		return this.$$.ctx[1];
	}

	set shopifyData(shopifyData) {
		this.$$set({ shopifyData });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Sticky_buy_box, {"shopifyData":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Sticky_buy_box);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-description-minimal.svelte":
/*!*******************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-description-minimal.svelte ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! svelte */ "./node_modules/svelte/src/runtime/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* js/components/landing-page-buy-box/variant-description-minimal.svelte generated by Svelte v4.2.19 */






function create_if_block(ctx) {
	let div0;
	let t0;
	let div0_class_value;
	let t1;
	let div1;
	let t2;
	let t3;
	let div1_class_value;
	let div1_style_value;

	return {
		c() {
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*calculatedCompareAtPrice*/ ctx[2]);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*calculatedDiscount*/ ctx[5]);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("% off");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[0]}__compare-price ${/*wrapperClass*/ ctx[0]}__price-box-item`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ ctx[0]}__discount ${/*wrapperClass*/ ctx[0]}__price-box-item`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "style", div1_style_value = `background: ${/*discountBgColor*/ ctx[1]};`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t3);
		},
		p(ctx, dirty) {
			if (dirty & /*calculatedCompareAtPrice*/ 4) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t0, /*calculatedCompareAtPrice*/ ctx[2]);

			if (dirty & /*wrapperClass*/ 1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[0]}__compare-price ${/*wrapperClass*/ ctx[0]}__price-box-item`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (dirty & /*calculatedDiscount*/ 32) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t2, /*calculatedDiscount*/ ctx[5]);

			if (dirty & /*wrapperClass*/ 1 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ ctx[0]}__discount ${/*wrapperClass*/ ctx[0]}__price-box-item`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}

			if (dirty & /*discountBgColor*/ 2 && div1_style_value !== (div1_style_value = `background: ${/*discountBgColor*/ ctx[1]};`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "style", div1_style_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div0);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
			}
		}
	};
}

function create_fragment(ctx) {
	let div3;
	let div1;
	let div0;
	let t0;
	let div0_class_value;
	let t1;
	let div1_class_value;
	let t2;
	let div2;
	let t3;
	let t4;
	let t5;
	let t6;
	let div2_class_value;
	let div3_class_value;
	let if_block = /*calculatedCompareAtPrice*/ ctx[2] && /*calculatedCompareAtPrice*/ ctx[2] != /*displayPrice*/ ctx[6] && /*calculatedDiscount*/ ctx[5] && create_if_block(ctx);

	return {
		c() {
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*displayPrice*/ ctx[6]);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*variantName*/ ctx[4]);
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(". ");
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*supplyInterval*/ ctx[3]);
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(".");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[0]}__selling-price ${/*wrapperClass*/ ctx[0]}__price-box-item`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ ctx[0]}__price-box`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value = `${/*wrapperClass*/ ctx[0]}__supply-info`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value = `${/*wrapperClass*/ ctx[0]}__description`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div3, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
			if (if_block) if_block.m(div1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t6);
		},
		p(ctx, [dirty]) {
			if (dirty & /*displayPrice*/ 64) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t0, /*displayPrice*/ ctx[6]);

			if (dirty & /*wrapperClass*/ 1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[0]}__selling-price ${/*wrapperClass*/ ctx[0]}__price-box-item`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (/*calculatedCompareAtPrice*/ ctx[2] && /*calculatedCompareAtPrice*/ ctx[2] != /*displayPrice*/ ctx[6] && /*calculatedDiscount*/ ctx[5]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div1, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*wrapperClass*/ 1 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ ctx[0]}__price-box`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}

			if (dirty & /*variantName*/ 16) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t3, /*variantName*/ ctx[4]);
			if (dirty & /*supplyInterval*/ 8) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t5, /*supplyInterval*/ ctx[3]);

			if (dirty & /*wrapperClass*/ 1 && div2_class_value !== (div2_class_value = `${/*wrapperClass*/ ctx[0]}__supply-info`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value);
			}

			if (dirty & /*wrapperClass*/ 1 && div3_class_value !== (div3_class_value = `${/*wrapperClass*/ ctx[0]}__description`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value);
			}
		},
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div3);
			}

			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let selectedVariantData;
	let price;
	let compareAtPrice;
	let discount;
	let priceWithoutCurrency;
	let displayPriceRaw;
	let displayPrice;
	let calculatedCompareAtPrice;
	let calculatedDiscount;
	let splitName;
	let variantName;
	let supplyInterval;
	let $selectedSellingPlanStore;
	let $selectedVariant;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedSellingPlanStore, $$value => $$invalidate(16, $selectedSellingPlanStore = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedVariant, $$value => $$invalidate(17, $selectedVariant = $$value));
	let { wrapperClass } = $$props;
	let { variantSelectorType } = $$props;
	let { productId } = $$props;
	let { finalDiscountedPrice } = $$props;
	let { showSubscription } = $$props;
	let { discountBgColor } = $$props;
	const currency = window.storeCurrency || 'USD';
	const locale = window.storeLocale || 'en-US';

	$$self.$$set = $$props => {
		if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
		if ('variantSelectorType' in $$props) $$invalidate(7, variantSelectorType = $$props.variantSelectorType);
		if ('productId' in $$props) $$invalidate(8, productId = $$props.productId);
		if ('finalDiscountedPrice' in $$props) $$invalidate(9, finalDiscountedPrice = $$props.finalDiscountedPrice);
		if ('showSubscription' in $$props) $$invalidate(10, showSubscription = $$props.showSubscription);
		if ('discountBgColor' in $$props) $$invalidate(1, discountBgColor = $$props.discountBgColor);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$selectedVariant, productId*/ 131328) {
			$: $$invalidate(12, selectedVariantData = $selectedVariant[productId]);
		}

		if ($$self.$$.dirty & /*selectedVariantData*/ 4096) {
			$: $$invalidate(13, { price, compareAtPrice = false, discount, priceWithoutCurrency } = selectedVariantData || {}, discount, ((($$invalidate(15, priceWithoutCurrency), $$invalidate(12, selectedVariantData)), $$invalidate(17, $selectedVariant)), $$invalidate(8, productId)));
		}

		if ($$self.$$.dirty & /*showSubscription, priceWithoutCurrency, $selectedSellingPlanStore, finalDiscountedPrice*/ 99840) {
			// When showSubscription is false, always use regular price (ignore manual discount calculations)
			// When showSubscription is true, use subscription price if selected, otherwise regular price
			$: $$invalidate(14, displayPriceRaw = (() => {
				if (!showSubscription) {
					// Always use regular price when subscriptions are hidden
					return priceWithoutCurrency;
				} else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice))) {
					// Use subscription price when subscriptions are shown and selected
					return parseFloat(finalDiscountedPrice);
				} else {
					// Use regular price when subscriptions are shown but not selected
					return priceWithoutCurrency;
				}
			})());
		}

		if ($$self.$$.dirty & /*displayPriceRaw*/ 16384) {
			$: $$invalidate(6, displayPrice = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(displayPriceRaw));
		}

		if ($$self.$$.dirty & /*showSubscription, selectedVariantData, $selectedSellingPlanStore, finalDiscountedPrice*/ 71168) {
			// Calculate compareAtPrice based on displayPrice when subscription is selected
			$: $$invalidate(2, calculatedCompareAtPrice = (() => {
				if (!showSubscription) {
					// Always use regular compareAtPrice when subscriptions are hidden
					return selectedVariantData?.compareAtPrice;
				} else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice))) {
					// Use subscription compareAtPrice when subscriptions are shown and selected
					return selectedVariantData?.compareAtPrice || selectedVariantData?.price;
				} else {
					// Use regular compareAtPrice when subscriptions are shown but not selected
					return selectedVariantData?.compareAtPrice;
				}
			})());
		}

		if ($$self.$$.dirty & /*showSubscription, discount, $selectedSellingPlanStore, finalDiscountedPrice, calculatedCompareAtPrice*/ 75268) {
			// Calculate discount percentage based on subscription selection
			$: $$invalidate(5, calculatedDiscount = (() => {
				if (!showSubscription) {
					// Always use regular discount when subscriptions are hidden
					return discount;
				} else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice)) && calculatedCompareAtPrice) {
					// Use subscription discount calculation when subscriptions are shown and selected
					return Math.round((parseFloat(calculatedCompareAtPrice.replace(/[^0-9.]/g, '')) - parseFloat(finalDiscountedPrice)) / parseFloat(calculatedCompareAtPrice.replace(/[^0-9.]/g, '')) * 100);
				} else {
					// Use regular discount when subscriptions are shown but not selected
					return discount;
				}
			})());
		}

		if ($$self.$$.dirty & /*selectedVariantData*/ 4096) {
			$: $$invalidate(11, splitName = selectedVariantData?.name?.split("-") || []);
		}

		if ($$self.$$.dirty & /*splitName*/ 2048) {
			$: $$invalidate(4, variantName = splitName[0]?.trim());
		}

		if ($$self.$$.dirty & /*splitName*/ 2048) {
			$: $$invalidate(3, supplyInterval = splitName[1]?.trim());
		}
	};

	return [
		wrapperClass,
		discountBgColor,
		calculatedCompareAtPrice,
		supplyInterval,
		variantName,
		calculatedDiscount,
		displayPrice,
		variantSelectorType,
		productId,
		finalDiscountedPrice,
		showSubscription,
		splitName,
		selectedVariantData,
		discount,
		displayPriceRaw,
		priceWithoutCurrency,
		$selectedSellingPlanStore,
		$selectedVariant
	];
}

class Variant_description_minimal extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
			wrapperClass: 0,
			variantSelectorType: 7,
			productId: 8,
			finalDiscountedPrice: 9,
			showSubscription: 10,
			discountBgColor: 1
		});
	}

	get wrapperClass() {
		return this.$$.ctx[0];
	}

	set wrapperClass(wrapperClass) {
		this.$$set({ wrapperClass });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get variantSelectorType() {
		return this.$$.ctx[7];
	}

	set variantSelectorType(variantSelectorType) {
		this.$$set({ variantSelectorType });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get productId() {
		return this.$$.ctx[8];
	}

	set productId(productId) {
		this.$$set({ productId });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get finalDiscountedPrice() {
		return this.$$.ctx[9];
	}

	set finalDiscountedPrice(finalDiscountedPrice) {
		this.$$set({ finalDiscountedPrice });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get showSubscription() {
		return this.$$.ctx[10];
	}

	set showSubscription(showSubscription) {
		this.$$set({ showSubscription });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get discountBgColor() {
		return this.$$.ctx[1];
	}

	set discountBgColor(discountBgColor) {
		this.$$set({ discountBgColor });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_description_minimal, {"wrapperClass":{},"variantSelectorType":{},"productId":{},"finalDiscountedPrice":{},"showSubscription":{},"discountBgColor":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_description_minimal);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-dropdown-selector.svelte":
/*!*****************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-dropdown-selector.svelte ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* js/components/landing-page-buy-box/variant-dropdown-selector.svelte generated by Svelte v4.2.19 */





function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[10] = list[i];
	return child_ctx;
}

// (41:10) {#each variantsMap as variant}
function create_each_block(ctx) {
	let option;
	let t0_value = /*variant*/ ctx[10].variantName + "";
	let t0;
	let t1;
	let t2_value = /*variant*/ ctx[10].supply + "";
	let t2;
	let t3;
	let option_value_value;

	return {
		c() {
			option = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("option");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("(");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(")");
			option.__value = option_value_value = /*variant*/ ctx[10].id;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(option, option.__value);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, option, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t3);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(option);
			}
		}
	};
}

// (39:6) {#key $selectedVariant[productId].id}
function create_key_block(ctx) {
	let select;
	let select_class_value;
	let mounted;
	let dispose;
	let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variantsMap*/ ctx[4]);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			select = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "class", select_class_value = `${/*wrapperClass*/ ctx[0]}__product-dropdown`);
			if (/*selectedVariantId*/ ctx[2] === void 0) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_render_callback)(() => /*select_change_handler*/ ctx[8].call(select));
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, select, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(select, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_option)(select, /*selectedVariantId*/ ctx[2], true);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(select, "change", /*select_change_handler*/ ctx[8]),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(select, "change", /*change_handler*/ ctx[9])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*variantsMap*/ 16) {
				each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variantsMap*/ ctx[4]);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*wrapperClass*/ 1 && select_class_value !== (select_class_value = `${/*wrapperClass*/ ctx[0]}__product-dropdown`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "class", select_class_value);
			}

			if (dirty & /*selectedVariantId, variantsMap*/ 20) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_option)(select, /*selectedVariantId*/ ctx[2]);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(select);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};
}

function create_fragment(ctx) {
	let div2;
	let div0;
	let t0;
	let div0_class_value;
	let t1;
	let div1;
	let previous_key = /*$selectedVariant*/ ctx[3][/*productId*/ ctx[1]].id;
	let div1_class_value;
	let div2_class_value;
	let key_block = create_key_block(ctx);

	return {
		c() {
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Select Size");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			key_block.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[0]}__product-info-heading`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ ctx[0]}__select-wrapper`);

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value = `
  ${/*wrapperClass*/ ctx[0]}__product-info-row
  ${/*wrapperClass*/ ctx[0]}__product-more-options
  ${/*wrapperClass*/ ctx[0]}__dropdown-selector
   `);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div2, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, div1);
			key_block.m(div1, null);
		},
		p(ctx, [dirty]) {
			if (dirty & /*wrapperClass*/ 1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[0]}__product-info-heading`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (dirty & /*$selectedVariant, productId*/ 10 && (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal)(previous_key, previous_key = /*$selectedVariant*/ ctx[3][/*productId*/ ctx[1]].id)) {
				key_block.d(1);
				key_block = create_key_block(ctx);
				key_block.c();
				key_block.m(div1, null);
			} else {
				key_block.p(ctx, dirty);
			}

			if (dirty & /*wrapperClass*/ 1 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ ctx[0]}__select-wrapper`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}

			if (dirty & /*wrapperClass*/ 1 && div2_class_value !== (div2_class_value = `
  ${/*wrapperClass*/ ctx[0]}__product-info-row
  ${/*wrapperClass*/ ctx[0]}__product-more-options
  ${/*wrapperClass*/ ctx[0]}__dropdown-selector
   `)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value);
			}
		},
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div2);
			}

			key_block.d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $selectedVariant;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedVariant, $$value => $$invalidate(3, $selectedVariant = $$value));
	let { variants } = $$props;
	let { callback } = $$props;
	let { wrapperClass } = $$props;
	let { productId } = $$props;

	const variantsMap = variants.map(item => {
		const { name, id } = item;
		const nameSplit = name.split('-');
		const variantName = nameSplit[0];
		const supply = nameSplit[1];
		return { id, variantName, supply };
	});

	const handleSelectChange = value => {
		$$invalidate(2, selectedVariantId = value);
	};

	let selectedVariantId = variants[variants.length - 1].id;

	function select_change_handler() {
		selectedVariantId = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_value)(this);
		$$invalidate(2, selectedVariantId);
		$$invalidate(4, variantsMap);
	}

	const change_handler = ev => {
		handleSelectChange(ev.target.value);
	};

	$$self.$$set = $$props => {
		if ('variants' in $$props) $$invalidate(6, variants = $$props.variants);
		if ('callback' in $$props) $$invalidate(7, callback = $$props.callback);
		if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
		if ('productId' in $$props) $$invalidate(1, productId = $$props.productId);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$selectedVariant, productId*/ 10) {
			$: (handleSelectChange($selectedVariant[productId].id), $selectedVariant);
		}

		if ($$self.$$.dirty & /*callback, selectedVariantId*/ 132) {
			$: (callback(selectedVariantId), selectedVariantId);
		}
	};

	return [
		wrapperClass,
		productId,
		selectedVariantId,
		$selectedVariant,
		variantsMap,
		handleSelectChange,
		variants,
		callback,
		select_change_handler,
		change_handler
	];
}

class Variant_dropdown_selector extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
			variants: 6,
			callback: 7,
			wrapperClass: 0,
			productId: 1
		});
	}

	get variants() {
		return this.$$.ctx[6];
	}

	set variants(variants) {
		this.$$set({ variants });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get callback() {
		return this.$$.ctx[7];
	}

	set callback(callback) {
		this.$$set({ callback });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get wrapperClass() {
		return this.$$.ctx[0];
	}

	set wrapperClass(wrapperClass) {
		this.$$set({ wrapperClass });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get productId() {
		return this.$$.ctx[1];
	}

	set productId(productId) {
		this.$$set({ productId });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_dropdown_selector, {"variants":{},"callback":{},"wrapperClass":{},"productId":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_dropdown_selector);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-options-selector.svelte":
/*!****************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-options-selector.svelte ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _variant_single_option_alternate_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./variant-single-option-alternate.svelte */ "./js/components/landing-page-buy-box/variant-single-option-alternate.svelte");
/* js/components/landing-page-buy-box/variant-options-selector.svelte generated by Svelte v4.2.19 */





function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

// (18:4) {#each variants as variant}
function create_each_block(ctx) {
	let variantsingleoptionalternate;
	let current;

	variantsingleoptionalternate = new _variant_single_option_alternate_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				variant: /*variant*/ ctx[4],
				callback: /*callback*/ ctx[1],
				wrapperClass: /*wrapperClass*/ ctx[2],
				productId: /*productId*/ ctx[3]
			}
		});

	return {
		c() {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantsingleoptionalternate.$$.fragment);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantsingleoptionalternate, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const variantsingleoptionalternate_changes = {};
			if (dirty & /*variants*/ 1) variantsingleoptionalternate_changes.variant = /*variant*/ ctx[4];
			if (dirty & /*callback*/ 2) variantsingleoptionalternate_changes.callback = /*callback*/ ctx[1];
			if (dirty & /*wrapperClass*/ 4) variantsingleoptionalternate_changes.wrapperClass = /*wrapperClass*/ ctx[2];
			if (dirty & /*productId*/ 8) variantsingleoptionalternate_changes.productId = /*productId*/ ctx[3];
			variantsingleoptionalternate.$set(variantsingleoptionalternate_changes);
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantsingleoptionalternate.$$.fragment, local);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantsingleoptionalternate.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantsingleoptionalternate, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let t0;
	let div0_class_value;
	let t1;
	let ul;
	let ul_class_value;
	let div1_class_value;
	let current;
	let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ ctx[0]);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Options:");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			ul = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-info-heading`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(ul, "class", ul_class_value = `${/*wrapperClass*/ ctx[2]}__product-options ${/*wrapperClass*/ ctx[2]}__product-options--${/*variants*/ ctx[0].length}-variants`);

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `
${/*wrapperClass*/ ctx[2]}__product-info-row
${/*wrapperClass*/ ctx[2]}__product-more-options
${/*wrapperClass*/ ctx[2]}__option-selector
 `);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(ul, null);
				}
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*wrapperClass*/ 4 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-info-heading`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (dirty & /*variants, callback, wrapperClass, productId*/ 15) {
				each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ ctx[0]);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
						each_blocks[i].m(ul, null);
					}
				}

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
			}

			if (!current || dirty & /*wrapperClass, variants*/ 5 && ul_class_value !== (ul_class_value = `${/*wrapperClass*/ ctx[2]}__product-options ${/*wrapperClass*/ ctx[2]}__product-options--${/*variants*/ ctx[0].length}-variants`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(ul, "class", ul_class_value);
			}

			if (!current || dirty & /*wrapperClass*/ 4 && div1_class_value !== (div1_class_value = `
${/*wrapperClass*/ ctx[2]}__product-info-row
${/*wrapperClass*/ ctx[2]}__product-more-options
${/*wrapperClass*/ ctx[2]}__option-selector
 `)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { variants } = $$props;
	let { callback } = $$props;
	let { wrapperClass } = $$props;
	let { productId } = $$props;

	$$self.$$set = $$props => {
		if ('variants' in $$props) $$invalidate(0, variants = $$props.variants);
		if ('callback' in $$props) $$invalidate(1, callback = $$props.callback);
		if ('wrapperClass' in $$props) $$invalidate(2, wrapperClass = $$props.wrapperClass);
		if ('productId' in $$props) $$invalidate(3, productId = $$props.productId);
	};

	return [variants, callback, wrapperClass, productId];
}

class Variant_options_selector extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
			variants: 0,
			callback: 1,
			wrapperClass: 2,
			productId: 3
		});
	}

	get variants() {
		return this.$$.ctx[0];
	}

	set variants(variants) {
		this.$$set({ variants });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get callback() {
		return this.$$.ctx[1];
	}

	set callback(callback) {
		this.$$set({ callback });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get wrapperClass() {
		return this.$$.ctx[2];
	}

	set wrapperClass(wrapperClass) {
		this.$$set({ wrapperClass });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get productId() {
		return this.$$.ctx[3];
	}

	set productId(productId) {
		this.$$set({ productId });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_options_selector, {"variants":{},"callback":{},"wrapperClass":{},"productId":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_options_selector);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-options.svelte":
/*!*******************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-options.svelte ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _variant_dropdown_selector_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./variant-dropdown-selector.svelte */ "./js/components/landing-page-buy-box/variant-dropdown-selector.svelte");
/* harmony import */ var _variant_options_selector_svelte__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./variant-options-selector.svelte */ "./js/components/landing-page-buy-box/variant-options-selector.svelte");
/* js/components/landing-page-buy-box/variant-options.svelte generated by Svelte v4.2.19 */







function create_else_block(ctx) {
	let variantdropdownselector;
	let current;

	variantdropdownselector = new _variant_dropdown_selector_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				variants: /*variants*/ ctx[0],
				callback: /*onChangeCallBack*/ ctx[3],
				wrapperClass: /*wrapperClass*/ ctx[1],
				productId: /*productId*/ ctx[2]
			}
		});

	return {
		c() {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantdropdownselector.$$.fragment);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantdropdownselector, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const variantdropdownselector_changes = {};
			if (dirty & /*variants*/ 1) variantdropdownselector_changes.variants = /*variants*/ ctx[0];
			if (dirty & /*wrapperClass*/ 2) variantdropdownselector_changes.wrapperClass = /*wrapperClass*/ ctx[1];
			if (dirty & /*productId*/ 4) variantdropdownselector_changes.productId = /*productId*/ ctx[2];
			variantdropdownselector.$set(variantdropdownselector_changes);
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantdropdownselector.$$.fragment, local);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantdropdownselector.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantdropdownselector, detaching);
		}
	};
}

// (19:0) {#if variantSelectorType == "default"}
function create_if_block(ctx) {
	let variantoptionsselector;
	let current;

	variantoptionsselector = new _variant_options_selector_svelte__WEBPACK_IMPORTED_MODULE_3__["default"]({
			props: {
				variants: /*variants*/ ctx[0],
				callback: /*onChangeCallBack*/ ctx[3],
				wrapperClass: /*wrapperClass*/ ctx[1],
				productId: /*productId*/ ctx[2]
			}
		});

	return {
		c() {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantoptionsselector.$$.fragment);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantoptionsselector, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const variantoptionsselector_changes = {};
			if (dirty & /*variants*/ 1) variantoptionsselector_changes.variants = /*variants*/ ctx[0];
			if (dirty & /*wrapperClass*/ 2) variantoptionsselector_changes.wrapperClass = /*wrapperClass*/ ctx[1];
			if (dirty & /*productId*/ 4) variantoptionsselector_changes.productId = /*productId*/ ctx[2];
			variantoptionsselector.$set(variantoptionsselector_changes);
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantoptionsselector.$$.fragment, local);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantoptionsselector.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantoptionsselector, detaching);
		}
	};
}

function create_fragment(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*variantSelectorType*/ ctx[4] == "default") return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if_block.p(ctx, dirty);
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(if_block_anchor);
			}

			if_blocks[current_block_type_index].d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { variants } = $$props;
	let { wrapperClass } = $$props;
	let { settings } = $$props;
	let { productId } = $$props;

	const onChangeCallBack = id => {
		const variantObj = variants.find(variant => variant.id == id);

		if (variantObj) {
			(0,_buy_box_store__WEBPACK_IMPORTED_MODULE_4__.updateSelectedVariant)({ variantObj, productId });
		}
	};

	const { variantSelectorType } = settings || {};

	$$self.$$set = $$props => {
		if ('variants' in $$props) $$invalidate(0, variants = $$props.variants);
		if ('wrapperClass' in $$props) $$invalidate(1, wrapperClass = $$props.wrapperClass);
		if ('settings' in $$props) $$invalidate(5, settings = $$props.settings);
		if ('productId' in $$props) $$invalidate(2, productId = $$props.productId);
	};

	return [
		variants,
		wrapperClass,
		productId,
		onChangeCallBack,
		variantSelectorType,
		settings
	];
}

class Variant_options extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
			variants: 0,
			wrapperClass: 1,
			settings: 5,
			productId: 2
		});
	}

	get variants() {
		return this.$$.ctx[0];
	}

	set variants(variants) {
		this.$$set({ variants });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get wrapperClass() {
		return this.$$.ctx[1];
	}

	set wrapperClass(wrapperClass) {
		this.$$set({ wrapperClass });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get settings() {
		return this.$$.ctx[5];
	}

	set settings(settings) {
		this.$$set({ settings });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get productId() {
		return this.$$.ctx[2];
	}

	set productId(productId) {
		this.$$set({ productId });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_options, {"variants":{},"wrapperClass":{},"settings":{},"productId":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_options);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-single-option-alternate.svelte":
/*!***********************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-single-option-alternate.svelte ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/responsive-image.svelte */ "./js/components/responsive-image.svelte");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* js/components/landing-page-buy-box/variant-single-option-alternate.svelte generated by Svelte v4.2.19 */






function create_else_block(ctx) {
	let div0;
	let t0;
	let div0_class_value;
	let t1;
	let div1;
	let t2;
	let div1_class_value;

	return {
		c() {
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*variantName*/ ctx[8]);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*variantNameMobile*/ ctx[7]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--desktop`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--mobile`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t2);
		},
		p(ctx, dirty) {
			if (dirty & /*wrapperClass*/ 4 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--desktop`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (dirty & /*wrapperClass*/ 4 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--mobile`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div0);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
			}
		}
	};
}

// (37:3) {#if flag}
function create_if_block(ctx) {
	let div0;
	let t0;
	let div0_class_value;
	let t1;
	let div1;
	let t2;
	let t3;
	let t4;
	let t5;
	let div1_class_value;

	return {
		c() {
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*customVariantName*/ ctx[9]);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*customVariantName*/ ctx[9]);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" (");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*customVariantNameMobile*/ ctx[10]);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(")");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--desktop`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--mobile`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t5);
		},
		p(ctx, dirty) {
			if (dirty & /*wrapperClass*/ 4 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--desktop`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (dirty & /*wrapperClass*/ 4 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-name landing-page-buy-box__product-option-info--mobile`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div0);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
			}
		}
	};
}

function create_fragment(ctx) {
	let div5;
	let div4;
	let div0;
	let responsiveimage;
	let div0_class_value;
	let t0;
	let div1;
	let div1_class_value;
	let t1;
	let div3;
	let t2;
	let div2;
	let t3;
	let div2_class_value;
	let div3_class_value;
	let div4_class_value;
	let div5_class_value;
	let current;
	let mounted;
	let dispose;

	responsiveimage = new JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				image: /*image*/ ctx[4],
				image_aspect_ratio: "1",
				objectFit: "cover",
				maxHeight: "78"
			}
		});

	function select_block_type(ctx, dirty) {
		if (flag) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(responsiveimage.$$.fragment);
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if_block.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*price*/ ctx[6]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-image`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ ctx[2]}__divider`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-price`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-info`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div4, "class", div4_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-link`);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div4, "data-variant-slide-id", "4");

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div5, "class", div5_class_value = `${/*wrapperClass*/ ctx[2]}__product-option ${/*$selectedVariant*/ ctx[3][/*productId*/ ctx[1]].id == /*id*/ ctx[5]
			? "selected"
			: ""}`);
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div5, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div5, div4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(responsiveimage, div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, div3);
			if_block.m(div3, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t3);
			current = true;

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(div5, "click", /*click_handler*/ ctx[12]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*wrapperClass*/ 4 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-image`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
			}

			if (!current || dirty & /*wrapperClass*/ 4 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ ctx[2]}__divider`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
			}

			if_block.p(ctx, dirty);

			if (!current || dirty & /*wrapperClass*/ 4 && div2_class_value !== (div2_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-price`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value);
			}

			if (!current || dirty & /*wrapperClass*/ 4 && div3_class_value !== (div3_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-info`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value);
			}

			if (!current || dirty & /*wrapperClass*/ 4 && div4_class_value !== (div4_class_value = `${/*wrapperClass*/ ctx[2]}__product-option-link`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div4, "class", div4_class_value);
			}

			if (!current || dirty & /*wrapperClass, $selectedVariant, productId*/ 14 && div5_class_value !== (div5_class_value = `${/*wrapperClass*/ ctx[2]}__product-option ${/*$selectedVariant*/ ctx[3][/*productId*/ ctx[1]].id == /*id*/ ctx[5]
			? "selected"
			: ""}`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div5, "class", div5_class_value);
			}
		},
		i(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(responsiveimage.$$.fragment, local);
			current = true;
		},
		o(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(responsiveimage.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div5);
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(responsiveimage);
			if_block.d();
			mounted = false;
			dispose();
		}
	};
}

const flag = true; //set true, to display custom variant name(metafield)

function instance($$self, $$props, $$invalidate) {
	let $selectedVariant;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedVariant, $$value => $$invalidate(3, $selectedVariant = $$value));
	let { variant } = $$props;
	let { callback } = $$props;
	let { productId } = $$props;
	let { wrapperClass } = $$props;
	const { image, name, id, price, customVariantText } = variant;
	const splitName = name.split("-");
	const variantNameMobile = name.replace(/-\s*(.*)/, "($1)");
	const variantName = splitName[0];
	const customVariantName = customVariantText;
	const customVariantNameMobile = splitName[1];

	const click_handler = () => {
		callback(id);
	};

	$$self.$$set = $$props => {
		if ('variant' in $$props) $$invalidate(11, variant = $$props.variant);
		if ('callback' in $$props) $$invalidate(0, callback = $$props.callback);
		if ('productId' in $$props) $$invalidate(1, productId = $$props.productId);
		if ('wrapperClass' in $$props) $$invalidate(2, wrapperClass = $$props.wrapperClass);
	};

	return [
		callback,
		productId,
		wrapperClass,
		$selectedVariant,
		image,
		id,
		price,
		variantNameMobile,
		variantName,
		customVariantName,
		customVariantNameMobile,
		variant,
		click_handler
	];
}

class Variant_single_option_alternate extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
			variant: 11,
			callback: 0,
			productId: 1,
			wrapperClass: 2
		});
	}

	get variant() {
		return this.$$.ctx[11];
	}

	set variant(variant) {
		this.$$set({ variant });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get callback() {
		return this.$$.ctx[0];
	}

	set callback(callback) {
		this.$$set({ callback });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get productId() {
		return this.$$.ctx[1];
	}

	set productId(productId) {
		this.$$set({ productId });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get wrapperClass() {
		return this.$$.ctx[2];
	}

	set wrapperClass(wrapperClass) {
		this.$$set({ wrapperClass });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_single_option_alternate, {"variant":{},"callback":{},"productId":{},"wrapperClass":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_single_option_alternate);

/***/ }),

/***/ "./js/components/responsive-image.svelte":
/*!***********************************************!*\
  !*** ./js/components/responsive-image.svelte ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* js/components/responsive-image.svelte generated by Svelte v4.2.19 */




function add_css(target) {
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_styles)(target, "svelte-vrirn3", ".responsive-image__wrapper.svelte-vrirn3:before{content:'';width:100%;display:block;padding-top:var(--padding-top)}.responsive-image__wrapper.svelte-vrirn3{max-width:var(--max-width);height:100%;position:relative;max-height:var(--max-height);height:auto;min-height:var(--min-height)}.responsive-image__image.svelte-vrirn3{position:absolute;top:0;height:100%;left:0;width:100%}");
}

function create_fragment(ctx) {
	let div;
	let img;
	let img_id_value;
	let img_src_value;
	let img_srcset_value;
	let img_style_value;
	let div_id_value;
	let div_style_value;

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			img = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("img");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "id", img_id_value = "Image-" + /*image_id*/ ctx[2] + "-" + /*generated_image_id*/ ctx[1]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "class", "responsive-image__image svelte-vrirn3");
			if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = /*srcUrl*/ ctx[4])) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "src", img_src_value);
			if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.srcset_url_equal)(img, img_srcset_value = /*imageSrcSet*/ ctx[3])) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "srcset", img_srcset_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "data-aspectratio", /*image_aspect_ratio*/ ctx[0]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "tabindex", "-1");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "style", img_style_value = /*getImageStyle*/ ctx[6]());
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "loading", "lazy");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "id", div_id_value = "ImageWrapper-" + /*image_id*/ ctx[2] + "-" + /*generated_image_id*/ ctx[1]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "data-image-id", /*image_id*/ ctx[2]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "responsive-image__wrapper svelte-vrirn3");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "style", div_style_value = /*getWrapperStyles*/ ctx[5]());
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, img);
		},
		p(ctx, [dirty]) {
			if (dirty & /*image_aspect_ratio*/ 1) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "data-aspectratio", /*image_aspect_ratio*/ ctx[0]);
			}
		},
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}
		}
	};
}

let min = 100;
let max = 10000;

function instance($$self, $$props, $$invalidate) {
	let { image_aspect_ratio } = $$props;
	let { image } = $$props;
	let { objectFit } = $$props;
	let { minHeight } = $$props;
	let { maxHeight } = $$props;
	let diff = max - min;
	let generated_image_id = Date.now() / diff + min;
	let displayImage = image;

	if (!displayImage) {
		displayImage = {
			width: 1920,
			height: 1080,
			id: Date.now(),
			src: 'https://cdn.shopify.com/s/files/1/0422/2255/1191/files/placeholderImage.webp?v=1692958737'
		};
	}

	let image_id = displayImage.id;
	let max_height_image = displayImage.height;
	let max_width_image = displayImage.width;

	const IMAGE_WIDTHS = [
		180,
		360,
		540,
		720,
		900,
		1080,
		1296,
		1512,
		1728,
		1944,
		2160,
		2376,
		2592,
		2808,
		3024
	];

	const getImageWidths = nativeWidth => {
		const imageWidths = [];

		for (let i = 0; i < IMAGE_WIDTHS.length; i++) {
			const width = IMAGE_WIDTHS[i];

			if (nativeWidth > width) {
				imageWidths.push(width);
			} else {
				imageWidths.push(nativeWidth);
				break;
			}
		}

		return imageWidths;
	};

	const imageSizes = getImageWidths(displayImage.width);

	const imageSrcSet = imageSizes.map(width => {
		return `${displayImage.src}&width=${width} ${width}w`;
	}).join(",");

	const max_width_image_float = max_width_image * 1.0;
	let srcUrl = `${displayImage.src}&width=10`;

	(aspectRatio => {
		if (aspectRatio <= 1) {
			max_height_image = image_height;
			max_width_image = max_height_image * image_aspect_ratio;
		} else {
			max_height_image = max_width_image / image_aspect_ratio;
		}
	})();

	const getWrapperStyles = () => {
		return `
    --padding-top: ${max_height_image / max_width_image_float * 100}%;
    --max-height: ${maxHeight || max_height_image}px;
    --max-width: ${max_width_image}px;
    --min-height: ${minHeight}px;
    `;
	};

	const getImageStyle = () => {
		return `
    max-width: ${max_width_image}px;
    max-height: ${max_height_image}px;
    object-fit: ${objectFit ? objectFit : 'contain'};`;
	};

	$$self.$$set = $$props => {
		if ('image_aspect_ratio' in $$props) $$invalidate(0, image_aspect_ratio = $$props.image_aspect_ratio);
		if ('image' in $$props) $$invalidate(7, image = $$props.image);
		if ('objectFit' in $$props) $$invalidate(8, objectFit = $$props.objectFit);
		if ('minHeight' in $$props) $$invalidate(9, minHeight = $$props.minHeight);
		if ('maxHeight' in $$props) $$invalidate(10, maxHeight = $$props.maxHeight);
	};

	return [
		image_aspect_ratio,
		generated_image_id,
		image_id,
		imageSrcSet,
		srcUrl,
		getWrapperStyles,
		getImageStyle,
		image,
		objectFit,
		minHeight,
		maxHeight
	];
}

class Responsive_image extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(
			this,
			options,
			instance,
			create_fragment,
			svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal,
			{
				image_aspect_ratio: 0,
				image: 7,
				objectFit: 8,
				minHeight: 9,
				maxHeight: 10
			},
			add_css
		);
	}

	get image_aspect_ratio() {
		return this.$$.ctx[0];
	}

	set image_aspect_ratio(image_aspect_ratio) {
		this.$$set({ image_aspect_ratio });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get image() {
		return this.$$.ctx[7];
	}

	set image(image) {
		this.$$set({ image });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get objectFit() {
		return this.$$.ctx[8];
	}

	set objectFit(objectFit) {
		this.$$set({ objectFit });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get minHeight() {
		return this.$$.ctx[9];
	}

	set minHeight(minHeight) {
		this.$$set({ minHeight });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}

	get maxHeight() {
		return this.$$.ctx[10];
	}

	set maxHeight(maxHeight) {
		this.$$set({ maxHeight });
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Responsive_image, {"image_aspect_ratio":{},"image":{},"objectFit":{},"minHeight":{},"maxHeight":{}}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Responsive_image);

/***/ }),

/***/ "./js/components/scroll-on-click.js":
/*!******************************************!*\
  !*** ./js/components/scroll-on-click.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   scrollOnClick: () => (/* binding */ scrollOnClick)
/* harmony export */ });
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! gsap */ "./node_modules/gsap/index.js");
/* harmony import */ var gsap_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gsap/ScrollToPlugin */ "./node_modules/gsap/ScrollToPlugin.js");


gsap__WEBPACK_IMPORTED_MODULE_0__.gsap.registerPlugin(gsap_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_1__.ScrollToPlugin);
var scrollOnClick = function scrollOnClick(selector, target) {
  var _document$querySelect;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  (_document$querySelect = document.querySelectorAll(selector)) === null || _document$querySelect === void 0 || _document$querySelect.forEach(item => item.addEventListener('click', ev => {
    ev.preventDefault();
    gsap__WEBPACK_IMPORTED_MODULE_0__.gsap.to(window, 1, {
      scrollTo: {
        y: target,
        offsetY: offset
      }
    });
  }));
};

/***/ }),

/***/ "./js/components/svelte-wrapper.js":
/*!*****************************************!*\
  !*** ./js/components/svelte-wrapper.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    var props = {};
    if (appTarget && !initialized) {
      var _props;
      if (propsEl) {
        var _appTarget$querySelec;
        props = json_6__WEBPACK_IMPORTED_MODULE_0___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
      }
      //inject component into container
      var instance = new Component({
        target: appTarget,
        props: {
          shopifyData: (_props = props) === null || _props === void 0 ? void 0 : _props.data //pass the prop on data prop as default
        }
      });
      appTarget.dataset.initialized = true;
      return instance;
    }
  });
});

/***/ })

}]);